module.exports = __webpack_public_path__ + "p.no1.5a2deaea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/p.no1.jpg
// module id = 0nnv
// module chunks = 0